import React, { useEffect, useState } from "react";
import { Table, Form, Button } from "react-bootstrap";
import Main from "../Components/Main";
import PageContainer from "../Components/PageContainer";
import CollapseCard from "../Components/CollapseCard";
import {
  getAllDistances,
  saveDistancesBulk,
} from "../Service/DistanceService";
import { getAllSources } from "../Service/SourceService";
import { getALLDestinations } from "../Service/DestinationService";
import { useToast } from "../Components/toast/ToastProvider";

const DistanceMasterPage = () => {
  const [sources, setSources] = useState([]);
  const [destinations, setDestinations] = useState([]);
  const [distanceData, setDistanceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [srcRes, destRes, distRes] = await Promise.all([
        getAllSources(),
        getALLDestinations(),
        getAllDistances(),
      ]);

      const srcList = srcRes?.data || srcRes || [];
      const destList = destRes?.data || destRes || [];
      const distList = distRes?.data || distRes || [];

      setSources((srcList) ? srcList : []);
      setDestinations((destList) ? destList : []);

      const combined = srcList.map((src) => {
        const destObj = {};

        destList.forEach((dest) => {
          const found = distList.find(
            (d) =>
              Number(d.source_id) === Number(src.id) &&
              Number(d.destination_id) === Number(dest.id)
          );
          destObj[dest.id] = found
            ? { id: found.id, km: Number(found.km) }
            : { id: 0, km: 0 };
        });

        return {
          source_id: src.id,
          source_title: src.title,
          destinations: destObj,
        };
      });

      setDistanceData(combined);
    } catch (err) {
      console.error("Error loading distance data:", err);
    }
  };

  const handleDistanceChange = async (rowIndex, destinationId, value) => {
    const updated = [...distanceData];
    updated[rowIndex].destinations[destinationId].km = Number(value) || 0;
    setDistanceData(updated);
  };

  const handleSaveAll = async () => {
    try {
      setLoading(true);

      const records = [];

      distanceData.forEach((row) => {
        Object.keys(row.destinations).forEach((destId) => {
          const { id, km } = row.destinations[destId];
          records.push({
            id: id || 0,
            source_id: row.source_id,
            destination_id: Number(destId),
            km,
          });
        });
      });

      await saveDistancesBulk({ records });
      setTimeout(() => {
        setLoading(false);
        toast("All distances saved or updated successfully!");
      }, 1500);
      // loadData(); 
    } catch (err) {
      console.error("Failed to save distances:", err);
      alert("Failed to save distances");
    }
  };

  const handleEnterKey = (e, rowIndex, destId) => {
    if (e.key !== "Enter") return;

    e.preventDefault();

    const totalRows = distanceData.length;
    const totalCols = destinations.length;

    const colIndex = destinations.findIndex((d) => d.id === destId);

    let nextRow = rowIndex;
    let nextCol = colIndex + 1;

    if (nextCol >= totalCols) {
      nextCol = 0;
      nextRow = rowIndex + 1;

    }

    if (nextRow >= totalRows) {
      const saveBtn = document.getElementById("saveBtn");
      if (saveBtn) saveBtn.focus();
      saveBtn.click();
      return;
    }

    const nextDestinationId = destinations[nextCol].id;
    const nextInput = document.getElementById(`Km-${nextRow}-${nextDestinationId}`);

    if (nextInput) nextInput.focus();
  }
  return (
    <Main>
      <PageContainer titlePage="Distance Master">
        <CollapseCard title="Distance Master">
          {sources.length === 0 || destinations.length === 0 ? (
            <p className="text-danger">
              Please add both Source and Destination first.
            </p>
          ) : (
            <div
              style={{
                maxHeight: "70vh",
                overflowY: "auto",
                overflowX: "auto",
              }}
            >

              <Table bordered hover responsive>
                <thead>
                  <tr>
                    <th>Source</th>
                    {destinations.map((dest) => (
                      <th key={dest.id} style={{ textTransform: 'capitalize' }}>{dest.title}</th>
                    ))}
                    {/* <th>Action</th> */}
                  </tr>
                </thead>
                <tbody>
                  {distanceData.map((row, rowIndex) => (
                    <tr key={row.source_id}>
                      <td style={{ textTransform: 'capitalize' }}>{row.source_title}</td>
                      {destinations.map((dest) => (
                        <td key={dest.id}>
                          <Form.Control
                            id={`Km-${rowIndex}-${dest.id}`}
                            type="number"
                            min={0}
                            value={row.destinations[dest.id]?.km ?? 0}
                            onChange={(e) =>
                              handleDistanceChange(
                                rowIndex,
                                dest.id,
                                e.target.value
                              )
                            }
                            style={{ width: "80px" }}
                            onKeyDown={(e) => handleEnterKey(e, rowIndex, dest.id)}
                          />
                        </td>
                      ))}
                      {/* <td>
                        <Button
                          variant="danger"
                          size="sm"
                          onClick={() => handleDeleteSource(rowIndex)}
                        >
                          <Trash size={14} />
                        </Button>
                      </td> */}
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="d-flex justify-content-end mt-2">
                <Button id="saveBtn" variant="primary" onClick={handleSaveAll}
                  disabled={loading}>
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2"></span>
                      saving...
                    </>
                  ) : (
                    "Save"
                  )}

                </Button>
              </div>

            </div>
          )}
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default DistanceMasterPage;
